import { createRouter, createWebHistory } from "vue-router";
import AddCardPage from "./pages/AddCardPage/AddCardPage.vue";
import DeckPage from "./pages/DeckPage.vue";
import PracticePage from "./pages/PracticePage.vue";
import LogoutPage from "./pages/LogoutPage.vue";
import HomePage from "./pages/HomePage.vue";
import StatsPage from "./pages/StatsPage.vue";
import NewLoginPage from "./pages/NewLoginPage.vue";
import PricingPage from "./pages/PricingPage/PricingPage.vue";
import { trackRouter } from "vue-gtag-next";

// 2. Define some routes
// Each route should map to a component.
// We'll talk about nested routes later.
const routes = [
  { path: "/", component: HomePage },
  { path: "/add", component: AddCardPage },
  { path: "/deck", component: DeckPage },
  { path: "/practice", component: PracticePage },
  { path: "/login", component: NewLoginPage },
  //{ path: "/login2", component: NewLoginPage },
  { path: "/logout", component: LogoutPage },
  { path: "/stats", component: StatsPage },
  {path: "/pricing", component: PricingPage },
];
// 3. Create the router instance and pass the `routes` option
// You can pass in additional options here, but let's
// keep it simple for now.
const router = createRouter({
  // 4. Provide the history implementation to use. We are using the hash history for simplicity here.
  history: createWebHistory(),
  routes, // short for `routes: routes`
});

trackRouter(router);
export {router}
